// getFocusVisualState — per-element visibility/opacity/emphasis resolver,
// extracted verbatim from InteractiveGraph.js (IG-split Slice 4). Pure: takes a
// single options object and returns { color, strokeColor, opacity, emphasis }.
// This is a load-bearing invariant of the renderer/overlay system — the
// signature and branch order are preserved exactly as they were inline.

export const getFocusVisualState = ({
  baseColor,
  fallbackColor = '#94a3b8',
  isVisible,
  isHighlighted,
  isShowAllStage,
  difficultyType,
  elementId,
  highlightedElements
}) => {
  const referenceColor = baseColor || fallbackColor || '#94a3b8';

  // 題幹キーワードからのハイライト（双方向ハイライト）
  const isKeywordHighlighted = Array.isArray(highlightedElements) && elementId && highlightedElements.includes(elementId);

  if (isShowAllStage || isKeywordHighlighted) {
    return {
      color: referenceColor,
      strokeColor: isKeywordHighlighted ? '#FFD700' : referenceColor,
      opacity: 1,
      emphasis: isKeywordHighlighted ? 'keyword_highlight' : 'full'
    };
  }

  if (!isVisible) {
    return {
      color: '#dbe0ea',
      strokeColor: '#c9ced9',
      opacity: 0.15,
      emphasis: 'hidden'
    };
  }

  if (isHighlighted) {
    return {
      color: referenceColor,
      strokeColor: referenceColor,
      opacity: 1,
      emphasis: 'focus'
    };
  }

  // 可視要素は常に元の色を使用（muted 廃止 — 全ステージ配色統一）
  return {
    color: referenceColor,
    strokeColor: referenceColor,
    opacity: 1,
    emphasis: 'full'
  };
};
